import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import StaffDashboard from "./pages/StaffDashboard";
import Fornitori from "./pages/Fornitori";
import Articoli from "./pages/Articoli";
import Personale from "./pages/Personale";
import Spese from "./pages/Spese";
import Chiusure from "./pages/Chiusure";
import Ordini from "./pages/Ordini";
import Utenti from "./pages/Utenti";
import Checklist from "./pages/Checklist";
import ListaSpesa from "./pages/ListaSpesa";
import Inventario from "./pages/Inventario";
import StoricoAttivita from "./pages/StoricoAttivita";
import Layout from "./components/Layout";
import { AuthProvider, useAuth } from "./context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const { token, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (token) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (user?.role !== 'admin') {
    return <Navigate to="/staff-dashboard" replace />;
  }
  
  return children;
};

const ReadOnlyRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  // Both admin and dipendente can access, but dipendente gets read-only version
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<AdminRoute><Dashboard /></AdminRoute>} />
            <Route path="staff-dashboard" element={<StaffDashboard />} />
            <Route path="fornitori" element={<ReadOnlyRoute><Fornitori /></ReadOnlyRoute>} />
            <Route path="articoli" element={<ReadOnlyRoute><Articoli /></ReadOnlyRoute>} />
            <Route path="personale" element={<AdminRoute><Personale /></AdminRoute>} />
            <Route path="spese" element={<Spese />} />
            <Route path="chiusure" element={<Chiusure />} />
            <Route path="ordini" element={<Ordini />} />
            <Route path="checklist" element={<Checklist />} />
            <Route path="lista-spesa" element={<ListaSpesa />} />
            <Route path="inventario" element={<Inventario />} />
            <Route path="storico-attivita" element={<AdminRoute><StoricoAttivita /></AdminRoute>} />
            <Route path="utenti" element={<AdminRoute><Utenti /></AdminRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
